export const FINANCES = [
    {
        id: 0,
        name: "Mission",
        image: "/assets/images/mission.jpeg",
        featured: true,
        description:"Time seeks to provide a full suite of Accounting, Auditing, valuation and business consultancy, training services for small businesses in A.A, Ethiopia, allowing business owners to not only save money over in-house accounting and ensure their compliance with tax laws, but to make valuable management decisions from their numbers."
    },
    {
        id: 1,
        name: "Tax Preparation",
        image: "/assets/images/fin3.jpeg",
        featured: false,
        description: "Tax Preparation Service. We have 10 Years of personal & business income tax preparation, sales tax preparation.  Preparing your tax return can be a quite difficult task that leaves you with more questions than answers."
    },
    {
        id: 2,
        name: "Book Keeping and Payroll",
        image: "/assets/images/fin2.jpeg",
        featured: false,
        description: "Bookkeeping & Payroll. Our Bookkeeping and Payroll services are designed to meet the needs of your business and are available to all small and large companies. We understand how overwhelming the payroll can be for your business owner when there are many other vital issues."
    },
]